module.exports = __webpack_public_path__ + "img/m.59519552.svg";